import {computed, inject, Injectable} from '@angular/core';
import {AuthSessionState} from '../auth/auth-session.state';
import {StoreDbService} from '../db/store.db.service';
import {TipoPuntoVentaEnum} from '../../shared/enums/tipo-punto-venta-enum';
import {NOMBRE_APLICACION} from '../../shared/constants/aplicacion.constant';
import {CORPORATE_MENU_PERMISSIONS} from '../constants/menu-permissions.constant';

@Injectable({providedIn: 'root'})
export class CorporateAuthorizationService {
  private readonly session = inject(AuthSessionState);
  private readonly storeDb = inject(StoreDbService);

  readonly esCorporativo = computed(
    () => this.storeDb.store()?.tipoPV === TipoPuntoVentaEnum.Corporativo
  );

  readonly permisos = computed<ReadonlySet<string>>(() => {
    const sociedad = this.storeDb.store()?.pais;
    const roles = this.session.rawBackend()?.roles ?? [];
    const permisos = roles
      .filter(role => role.aplicacion.toLocaleLowerCase() === NOMBRE_APLICACION.toLocaleLowerCase())
      .filter(role => !sociedad || role.sociedad === sociedad)
      .flatMap(role => role.permisos)
      .map(item => item.permiso.trim())
      .filter(Boolean);

    return new Set(permisos);
  });

  tienePermiso(permiso: string): boolean {
    return this.permisos().has(permiso);
  }

  requiereValidacion(permiso?: string): boolean {
    return Boolean(permiso && CORPORATE_MENU_PERMISSIONS.has(permiso));
  }

  puedeAcceder(permiso?: string): boolean {
    if (!this.esCorporativo() || !this.requiereValidacion(permiso)) {
      return true;
    }

    return this.tienePermiso(permiso!);
  }
}
